module.exports = __webpack_public_path__ + "static/media/atago-icon.09ac91c2.png";